import type { TooltipProps } from 'recharts';

/**
 * Shared tooltip used by every chart in the season-scoped insights feature.
 * White surface, 1px solid gold border, display label, small-caps gold metric
 * name, tabular-nums for values. Never renders when payload is empty.
 */
export function CustomChartTooltip({
  active,
  payload,
  label,
}: TooltipProps<number, string>) {
  if (!active || !payload || payload.length === 0) return null;
  return (
    <div className="bg-white border border-gold-100 rounded-lg shadow-subtle px-3 py-2 CustomChartTooltip">
      <div className="font-display text-sm text-gold-950">{String(label ?? '')}</div>
      {payload.map((p, i) => (
        <div key={`${p.dataKey ?? 'v'}-${i}`} className="flex items-center gap-2 mt-1">
          <span
            className="w-2 h-2 rounded-full inline-block"
            style={{ background: p.color ?? '#3d2f0b' }}
            aria-hidden
          />
          <span className="text-eyebrow-sm font-extrabold text-gold-500">
            {p.name}
          </span>
          <span className="font-sans text-xs tabular-nums text-gold-950">
            {typeof p.value === 'number' ? p.value.toLocaleString() : String(p.value)}
          </span>
        </div>
      ))}
    </div>
  );
}
